function helperGetDateTime (date) {
  return date.getTime()
}

module.exports = helperGetDateTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/helperGetDateTime.js
// module id = 49
// module chunks = 75